import { RegisterUser } from "@/features/account/components/register/register-user";

function Register() {
    return <RegisterUser />;
}

export default Register;
